var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "free-delivery" },
    [
      _c("ob1-liens", {
        attrs: {
          "is-mini": true,
          "is-button": true,
          "modal-id": _vm.id,
          text: _vm.stockAndDeliveryMention,
          "with-arrow": true,
        },
      }),
      _vm._v(" "),
      _c(
        "ob1-popin-modal2",
        { attrs: { id: _vm.id, "aria-labelledby": _vm.ariaLabelId } },
        [
          _c("h3", { attrs: { id: _vm.ariaLabelId } }, [
            _vm._v(
              "\n            " + _vm._s(_vm.deliveryModalTitle) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "shop" }, [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("h4", [_vm._v(_vm._s(_vm.shopDeliveryTitle))]),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(_vm.freeDeliveryLabel))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("span", {
                  staticClass: "bold",
                  domProps: { innerHTML: _vm._s(_vm.ecoLabel) },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "icon icon-Eco-mode h4 mb-0",
                  attrs: { "aria-hidden": "true" },
                }),
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.shopDeliveryText) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pickup" }, [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("h4", [_vm._v(_vm._s(_vm.pickupDeliveryTitle))]),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(_vm.freeDeliveryLabel))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("span", {
                  staticClass: "bold",
                  domProps: { innerHTML: _vm._s(_vm.ecoLabel) },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "icon icon-Eco-mode h4 mb-0",
                  attrs: { "aria-hidden": "true" },
                }),
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.pickupDeliveryText) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "otherAddress" }, [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("h4", [_vm._v(_vm._s(_vm.otherAddressTitle))]),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(_vm.otherAddressDeliveryFees))]),
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.otherAddressText) },
              }),
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "separator separator--gray4 my-2" }),
            _vm._v(" "),
            _c("p", { domProps: { innerHTML: _vm._s(_vm.ecoLabelMention) } }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }